import React from 'react';
import type { DividerBlockContent } from '../../../types/popup.types';

interface DividerBlockProps {
  content: DividerBlockContent;
}

const DividerBlock: React.FC<DividerBlockProps> = ({ content }) => {
  const { style, color, thickness, margin } = content;

  return (
    <hr
      className="my-4"
      style={{
        border: 'none',
        borderTop: `${thickness || 1}px ${style || 'solid'} ${color || '#e0e0e0'}`,
        margin: `${margin || 16}px 0`,
      }}
    />
  );
};

export default DividerBlock;
